import {create} from 'zustand';
import {inventoryApi} from '../services/api/inventoryApi';

export const useInventoryStore = create((set) => ({
  materialUnits: [],
  materialTypes: [],
  readymadeTypes: [],
  readymadeSizes: [],
  isLoading: false,

  // Material Units
  fetchMaterialUnits: async () => {
    set({isLoading: true});
    try {
      const response = await inventoryApi.materialUnits.list();
      set({materialUnits: response.data.data});
    } finally {
      set({isLoading: false});
    }
  },
  createMaterialUnit: async (data) => {
    const response = await inventoryApi.materialUnits.create(data);
    const newItem = response.data.data;
    set(state => ({materialUnits: [...state.materialUnits, newItem]}));
    return newItem;
  },
  updateMaterialUnit: async (id, data) => {
    const response = await inventoryApi.materialUnits.update(id, data);
    const updated = response.data.data;
    set(state => ({
      materialUnits: state.materialUnits.map(a => (a.id === id ? updated : a)),
    }));
    return updated;
  },
  deleteMaterialUnit: async (id) => {
    await inventoryApi.materialUnits.remove(id);
    set(state => ({
      materialUnits: state.materialUnits.filter(a => a.id !== id),
    }));
  },

  // Material Types
  fetchMaterialTypes: async () => {
    set({isLoading: true});
    try {
      const response = await inventoryApi.materialTypes.list();
      set({materialTypes: response.data.data});
    } finally {
      set({isLoading: false});
    }
  },
  createMaterialType: async (data) => {
    const response = await inventoryApi.materialTypes.create(data);
    const newItem = response.data.data;
    set(state => ({materialTypes: [...state.materialTypes, newItem]}));
    return newItem;
  },
  updateMaterialType: async (id, data) => {
    const response = await inventoryApi.materialTypes.update(id, data);
    const updated = response.data.data;
    set(state => ({
      materialTypes: state.materialTypes.map(a => (a.id === id ? updated : a)),
    }));
    return updated;
  },
  deleteMaterialType: async (id) => {
    await inventoryApi.materialTypes.remove(id);
    set(state => ({
      materialTypes: state.materialTypes.filter(a => a.id !== id),
    }));
  },

  // Readymade Types
  fetchReadymadeTypes: async () => {
    set({isLoading: true});
    try {
      const response = await inventoryApi.readymadeTypes.list();
      set({readymadeTypes: response.data.data});
    } finally {
      set({isLoading: false});
    }
  },
  createReadymadeType: async (data) => {
    const response = await inventoryApi.readymadeTypes.create(data);
    const newItem = response.data.data;
    set(state => ({readymadeTypes: [...state.readymadeTypes, newItem]}));
    return newItem;
  },
  updateReadymadeType: async (id, data) => {
    const response = await inventoryApi.readymadeTypes.update(id, data);
    const updated = response.data.data;
    set(state => ({
      readymadeTypes: state.readymadeTypes.map(a => (a.id === id ? updated : a)),
    }));
    return updated;
  },
  deleteReadymadeType: async (id) => {
    await inventoryApi.readymadeTypes.remove(id);
    set(state => ({
      readymadeTypes: state.readymadeTypes.filter(a => a.id !== id),
    }));
  },

  // Readymade Sizes
  fetchReadymadeSizes: async () => {
    set({isLoading: true});
    try {
      const response = await inventoryApi.readymadeSizes.list();
      set({readymadeSizes: response.data.data});
    } finally {
      set({isLoading: false});
    }
  },
  createReadymadeSize: async (data) => {
    const response = await inventoryApi.readymadeSizes.create(data);
    const newItem = response.data.data;
    set(state => ({readymadeSizes: [...state.readymadeSizes, newItem]}));
    return newItem;
  },
  updateReadymadeSize: async (id, data) => {
    const response = await inventoryApi.readymadeSizes.update(id, data);
    const updated = response.data.data;
    set(state => ({
      readymadeSizes: state.readymadeSizes.map(a => (a.id === id ? updated : a)),
    }));
    return updated;
  },
  deleteReadymadeSize: async (id) => {
    await inventoryApi.readymadeSizes.remove(id);
    set(state => ({
      readymadeSizes: state.readymadeSizes.filter(a => a.id !== id),
    }));
  },
}));
